import { statusSelectOptions } from 'utils/translate'
import { POSITION_FIELD, STATUS_FIELD } from './model'

export const mapInternalStateToPayload = state => {
  const { position, status } = state ?? {}

  return {
    project: position?.value,
    status: status?.value,
  }
}

export const mapPositionToInternalState = state => {
  const { id, name, status, hasInterviewModule } = state ?? {}

  return {
    [POSITION_FIELD]: { label: name, value: id },
    [STATUS_FIELD]: statusSelectOptions({ hasInterviewModule }).find(
      ({ value }) => value === status,
    ),
  }
}
